import { getPath } from '@/router/common'

const baseUrl = {
  title: '现金收支汇总表',
  path: 'CashClassReport'
}

export default [
  {
    path: getPath('CashSZReport', baseUrl),
    name: 'CashClassReport_CashSZReport',
    component: () => import(/* webpackChunkName: "CashClassReport_CashSZReport" */ '@/views/cashClassReport/cashSZReport/index.vue'),
    meta: {
      title: '现金收支汇总表'
    }
  }
]
